import { Container } from './styles';

export function ForgotPasswordContent(): JSX.Element {
  return <Container />;
}
